/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Gikondo 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Kagunga": ["Gatare", "Kabuye I", "Kabuye II", "Kagunga I", "Kagunga II", "Rebero"],
  "Kanserege": ["Kanserege I", "Kanserege II", "Kanserege III", "Marembo I", "Marembo II", "Marembo III"],
  "Kinunga": ["Kigugu I", "Kigugu II", "Kigugu III", "Kinunga", "Ruganwa I", "Ruganwa II", "Ruganwa III"]
};